export default __webpack_public_path__ + "static/media/working_with_computer.73a9330d.svg";